import React, { useState, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import MutualsService from '../../services/mutuals/mutuals.service'
import { validators } from '../../utils/helpers/validators'
import Button from '../common/buttons'
import { SubTitle } from '../common/form-components/label/Label'
import useInputs from '../../utils/hooks/useInputs'
import { mutualsPathname } from '../../routes/settings/pathname'
import DeleteButton from '../common/buttons/DeleteButton'
import SaveButton from '../common/buttons/SaveButton'
import './mutualForm.scss'
import LabeledText from '../common/form-components/labeled-inputs/LabeledText'

const MutualForm = ({ mutualId, submit }) => {
  const navigate = useNavigate()

  const { inputs, onChangeInputs, updateInputs } = useInputs()
  const [newAddress, setNewAddress] = useState('')

  useEffect(() => {
    if (mutualId !== undefined) {
      getMutual()
    }
  }, [])

  const getMutual = async () => {
    const response = await MutualsService.getById(mutualId)
    if (response) {
      updateInputs(response.resp)
      return
    }
    navigate(mutualsPathname.MUTUALS)
  }

  const removeItemAddress = (item) => {
    updateInputs({
      ...inputs,
      addresses: inputs?.addresses.filter((x) => x !== item),
    })
  }

  const addItemAddress = () => {
    if (Array.isArray(inputs.addresses)) {
      updateInputs({ ...inputs, addresses: [...inputs.addresses, newAddress] })
    } else {
      updateInputs({ ...inputs, addresses: [newAddress] })
    }
    setNewAddress('')
  }

  const validateForm = validators.hasValue(inputs?.name)

  const renderAddresses = () => {
    return (
      <ul className="addresses-list">
        {inputs?.addresses?.map((address) => {
          return (
            <li className="address" key={Math.random()}>
              {address}
              <DeleteButton onClick={() => removeItemAddress(address)} />
            </li>
          )
        })}
      </ul>
    )
  }

  return (
    <div className="add-mutuals-container ">
      <div className="modal-content-wrapper">
        <LabeledText
          idLabel="name"
          required
          name="name"
          value={inputs?.name}
          onChange={(e) => onChangeInputs(e)}
        />
        <LabeledText
          idLabel="address"
          name="newAddress"
          value={newAddress}
          onChange={(e) => setNewAddress(e.target.value)}
        />

        <div className="flex-container">
          <SubTitle id="addresses.added" />
          {inputs?.addresses?.length > 0 ? (
            renderAddresses()
          ) : (
            <FormattedMessage id="placeholder.not.data" />
          )}
        </div>
      </div>

      <div className="modal-btn-container">
        <Button
          id="add-address"
          btnText={<FormattedMessage id="button.add.address" />}
          btnType="button"
          btnClass="btn__transparent mr__05"
          isDisabled={newAddress === ''}
          onHandleClick={() => addItemAddress()}
        />
        <SaveButton
          btnClass="btn-save-modal"
          onClick={() => submit(inputs)}
          isDisabled={!validateForm}
        />
      </div>
    </div>
  )
}

export default MutualForm
